<template>
  <div v-for="(comp, index) in competitions" :key="index">
    <CompetitionsCard
      :competition="comp"
      :registerTeam="() => handleDialogChange(comp.id)"
    />
  </div>

  <v-dialog v-model="teamDialog" max-width="700px">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <h6 class="text-h6">
              {{
                competitions?.find((e) => e.id === competitionId)?.name
              }}
              regisztráció
            </h6>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              return-object
              :items="schoolList"
              label="Iskola neve"
              hint="Kezdje el beírni az iskola nevét, majd válasszon a listából"
              variant="underlined"
              @update:search="filterSchools"
              v-model="registerForm.school"
            >
              <template #no-data>
                <v-list-item>Nincs találat. Kezdjen el gépelni!</v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              type="text"
              label="Csapat neve"
              placeholder="Pl. A győztesek"
              hint="Adjon nevet a csapatnak!"
              variant="underlined"
              v-model="registerForm.name"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="green" @click="registerTeam">Register Team </v-btn>
        <v-btn @click="handleDialogChange">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <TeamNameTakenDialog
    v-if="isTeamDialogVisable"
    :showdialog="isTeamDialogVisable"
    @dialogChange="handleTeamDialogChange"
  />
</template>
<script>
import { defineComponent } from 'vue'
import CompetitionsCard from '../components/CompetitionCard.vue'
import TeamNameTakenDialog from '../components/TeamNameTakenDialog.vue'
import { getUserCompetitions } from '../services/formServices'
import { getAllInstitutions } from '../services/adminServices'
import { checkTeamName, postTeam } from '../services/teamServices'

export default defineComponent({
  name: `InfoPage`,
  components: {
    CompetitionsCard,
    TeamNameTakenDialog,
  },
  data: () => {
    return {
      schoolList: [],
      schools: [],
      teamDialog: false,
      competitionId: null,
      isTeamDialogVisable: false,
      competitions: [],
      registerForm: {
        name: '',
        school: null,
      },
    }
  },
  async created() {
    await this.getCompetitionData()
    const institutions = await getAllInstitutions()
    if (institutions) {
      this.schools = institutions
    }
  },
  methods: {
    async getCompetitionData() {
      const comps = await getUserCompetitions()
      if(!comps) return []
      this.competitions = comps.map((e) => {
        return {
          id: e.id,
          name: e.name,
          fillableFrom: new Date(e.fillable_from),
          fillableTo: new Date(e.fillable_to),
          shortDescription: e.description || '',
          isTeam: e.is_team,
          isRegister: e.is_register,
          reading: e.reading || '',
          isDone: e.is_done,
        }
      })
    },
    filterSchools(val) {
      if (val.length > 2) {
        this.schoolList = this.schools.filter((school) => {
          return school.title.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
    },
    handleDialogChange(competitionId) {
      if (competitionId) [(this.competitionId = competitionId)]
      this.teamDialog = !this.teamDialog
    },

    async registerTeam() {
      const checkTeamIsTaken = await checkTeamName(
        this.registerForm.name,
        this.competitionId
      )
      if (!checkTeamIsTaken) {
        this.isTeamDialogVisable = true
        return
      }
      this.isSaveDialogVisible = true
      setTimeout(() => {
        this.isSaveDialogVisible = false
      }, 1500)

      const result = await postTeam(this.registerForm, this.competitionId)
      this.hasTeam = result.data
      this.handleDialogChange()
      this.getCompetitionData()
    },
    handleTeamDialogChange() {
      this.isTeamDialogVisable = false
    },
  },
})
</script>
